export default __webpack_public_path__ + "static/media/hotel2.76466d22.jpg";